
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v3.0.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("d1G3o"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("hLG8e"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS _42Yu6BsWIj",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $cozmU.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $cozmU.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("bjVRl", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $8s9DV.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $kBr4q.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $kBr4q.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("d1G3o", function(module, exports) {

let $97bbfd5f86a5182d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $97bbfd5f86a5182d$var$load("953Uz"),
    $97bbfd5f86a5182d$var$load("fdsim")
]).then(()=>parcelRequire('jgOPc'));

});

parcelRegister("hLG8e", function(module, exports) {

let $cef781ec6d7dbd24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cef781ec6d7dbd24$var$load("9ElG9"),
    $cef781ec6d7dbd24$var$load("gqGHu"),
    $cef781ec6d7dbd24$var$load("exK5D"),
    $cef781ec6d7dbd24$var$load("1ThhV"),
    $cef781ec6d7dbd24$var$load("2OemJ"),
    $cef781ec6d7dbd24$var$load("d1n8n"),
    $cef781ec6d7dbd24$var$load("hUbK8"),
    $cef781ec6d7dbd24$var$load("lGZLW"),
    $cef781ec6d7dbd24$var$load("5KHgm"),
    $cef781ec6d7dbd24$var$load("fcAaN"),
    $cef781ec6d7dbd24$var$load("alg5Q"),
    $cef781ec6d7dbd24$var$load("jgFQ5"),
    $cef781ec6d7dbd24$var$load("1Gr4q"),
    $cef781ec6d7dbd24$var$load("2mGc6"),
    $cef781ec6d7dbd24$var$load("fB5NV"),
    $cef781ec6d7dbd24$var$load("ir5Be"),
    $cef781ec6d7dbd24$var$load("kccW9"),
    $cef781ec6d7dbd24$var$load("iPvQ1"),
    $cef781ec6d7dbd24$var$load("8yk9S"),
    $cef781ec6d7dbd24$var$load("iOfkQ"),
    $cef781ec6d7dbd24$var$load("eeYoU"),
    $cef781ec6d7dbd24$var$load("7SteV"),
    $cef781ec6d7dbd24$var$load("do0Fh"),
    $cef781ec6d7dbd24$var$load("1cQg7"),
    $cef781ec6d7dbd24$var$load("2o2NN"),
    $cef781ec6d7dbd24$var$load("kUh5E"),
    $cef781ec6d7dbd24$var$load("dxcsb"),
    $cef781ec6d7dbd24$var$load("jqoep"),
    $cef781ec6d7dbd24$var$load("3R4oU"),
    $cef781ec6d7dbd24$var$load("3vH95"),
    $cef781ec6d7dbd24$var$load("fnO1K"),
    $cef781ec6d7dbd24$var$load("7LDtT"),
    $cef781ec6d7dbd24$var$load("cIf37"),
    $cef781ec6d7dbd24$var$load("asveJ"),
    $cef781ec6d7dbd24$var$load("fKQ9j"),
    $cef781ec6d7dbd24$var$load("jGIxd"),
    $cef781ec6d7dbd24$var$load("3Hi3V"),
    $cef781ec6d7dbd24$var$load("4x9Jx"),
    $cef781ec6d7dbd24$var$load("ea3NB"),
    $cef781ec6d7dbd24$var$load("6wr18"),
    $cef781ec6d7dbd24$var$load("59hV4"),
    $cef781ec6d7dbd24$var$load("fibpY"),
    $cef781ec6d7dbd24$var$load("4O6U4"),
    $cef781ec6d7dbd24$var$load("5He1y"),
    $cef781ec6d7dbd24$var$load("6vqGz"),
    $cef781ec6d7dbd24$var$load("ffEVr"),
    $cef781ec6d7dbd24$var$load("i7f39"),
    $cef781ec6d7dbd24$var$load("hwJJ4"),
    $cef781ec6d7dbd24$var$load("kDTjZ"),
    $cef781ec6d7dbd24$var$load("crqUW"),
    $cef781ec6d7dbd24$var$load("3Ukuo"),
    $cef781ec6d7dbd24$var$load("Wowvf"),
    $cef781ec6d7dbd24$var$load("lkxmG"),
    $cef781ec6d7dbd24$var$load("Lm7SH"),
    $cef781ec6d7dbd24$var$load("hhss7"),
    $cef781ec6d7dbd24$var$load("aAWLw"),
    $cef781ec6d7dbd24$var$load("7EorR"),
    $cef781ec6d7dbd24$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.67a0841c.js.map
